module.exports = __webpack_public_path__ + "static/media/traycorp5.da3a1951.png";